export interface TableItem {
  [x: string]: any;
  id: string | number;
}

export enum ColDataType {
  DATE = 'date',
  DATE_TIME = 'datetime',
}
export interface TableColumn {
  accessor: string;
  name: string;
  dataType?: ColDataType;
  innerAccesor?: string;
  hideFilter?: boolean;
  searchInput?: boolean;
  className?: string;
  translateEnum?: any;
  cellRenderer?: (e: any) => any;
}

export interface CustomButton {
  title?: string;
  icon?: JSX.Element;
  color?: 'blue' | 'red' | 'gray' | 'green';
  onlyIcon?: boolean;
  className?: string;
  idKey?: string;
  showLoading?: boolean;
  renderCondition?: (id: string | number) => boolean;
  onSubmit: (id: string | number) => void;
}

export interface ColFilter {
  column: string;
  filter: string[];
}

export interface ContextMenuItem {
  label: string;
  action: (id: number) => void;
}

export enum DensityType {
  COMPACT = 'compact',
  NORMAL = 'normal',
}
